import { DOCUMENT } from '@angular/common';
import { Directive, Inject, OnInit, Renderer2 } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { VatNumberService } from '@luggagehero/services';

@Directive({
  selector: '[lhVatNumber]',
  providers: [{ provide: NG_VALIDATORS, useExisting: VatNumberDirective, multi: true }],
})
export class VatNumberDirective implements Validator, OnInit {
  constructor(
    private vatNumberService: VatNumberService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document,
  ) {}

  public async ngOnInit() {
    await this.vatNumberService.init(this.renderer, this.document);
  }

  public validate(control: AbstractControl): { [key: string]: unknown } | null {
    return this.vatNumberService.validate(control);
  }
}
